export enum EVideoTabSectionKey {
  Videos = 'Video_Videos',
}

export interface IVideoTabVideosSection {
  videos: {
    videoUrl: string;
    thumbnail: string;
    title: string;
    content: string;
    createdAt: string;
  }[];
}

export type TEnterpriseProfileVideoTabSectionElements = IVideoTabVideosSection;

export type TEnterpriseProfileVideoTabSection = {
  sectionName: string;
  sectionKey: EVideoTabSectionKey;
  elements?: TEnterpriseProfileVideoTabSectionElements;
  isActive: boolean;
}[];
